import { objectSpread2 as _objectSpread2 } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import PendoTooltip from '../../../directives/tooltip/pendo-tooltip.js';
import PendoIcon from '../../icon/pendo-icon.vue.js';
import { shouldAttachOverflowTooltip } from '../multiselect-helper.js';

var script = {
  name: 'PendoIconOption',
  components: {
    PendoIcon
  },
  directives: {
    PendoTooltip
  },
  inject: ['multiselect'],
  props: {
    option: {
      type: [Object, String],
      required: true
    }
  },
  data() {
    return {
      showOverflowTooltip: false,
      tooltipTimeout: null
    };
  },
  computed: {
    label() {
      return this.multiselect.getOptionLabel(this.option);
    },
    icon() {
      if (this.option.icon) {
        return _objectSpread2({
          size: 14
        }, this.option.icon);
      }
      let type;
      if (['feature', 'page', 'trackType', 'guide', 'guideElement', 'poll'].includes(this.option.id)) {
        type = this.option.id;
      } else if (['resourceCenter'].includes(this.option.id)) {
        type = 'guide';
      } else if (['feedbackRequest', 'idea'].includes(this.option.id)) {
        type = 'lightbulb';
      } else if (['visitor', 'account', 'parentAccount'].includes(this.option.kind)) {
        type = this.option.kind;
      } else if (['ios', 'android', 'web', 'extension'].includes(this.option.platform)) {
        type = this.generateAppTypeIcon(this.option.platform);
      }
      if (type) {
        return {
          size: 14,
          type
        };
      }
      return null;
    }
  },
  methods: {
    onOptionMouseenter() {
      const showOverflowTooltip = shouldAttachOverflowTooltip(this.label, this.$refs.label);
      if (showOverflowTooltip) {
        clearTimeout(this.tooltipTimeout);
        this.tooltipTimeout = setTimeout(() => {
          this.showOverflowTooltip = true;
        }, 300);
      }
    },
    onOptionMouseleave() {
      clearTimeout(this.tooltipTimeout);
      this.showOverflowTooltip = false;
    },
    generateAppTypeIcon(platform) {
      if (platform === 'web') {
        return 'monitor';
      }
      if (platform === 'extension') {
        return 'puzzle-piece';
      }
      return platform;
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-icon-option.vue2.js.map
